import { Turbo } from "@hotwired/turbo-rails";
import htmx from "htmx.org";
import Rails from "@rails/ujs";

Turbo.session.drive = false;
Rails.start();
window.htmx = htmx;

htmx.config.globalViewTransitions = true;

import "./settings";

import "./menu/inventory_item";
import "./menu/calorie_inputs";
import "./menu/pos_identifier_search";

import "./sortable";

// Workaround to ensure tokens are refreshed for form submission.
document.addEventListener("turbo:load", () => Rails.refreshCSRFTokens());
document.addEventListener("DOMContentLoaded", () => Rails.refreshCSRFTokens());
document.addEventListener("htmx:configRequest", (event) => {
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;
  if (csrfToken) event.detail.headers["X-CSRF-Token"] = csrfToken;
});
